import React, { Suspense, lazy, useRef, useCallback } from "react";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { useActiveMeasurementSession } from "../recording/session/ActiveMeasurementSessionContext";

const RecordingTidalBreathing = lazy(
  () => import("recordingTidalBreathing/App"),
);

export default function RecordingTidalBreathingRouter(props) {
  const navigate = useNavigate();
  const didRedirectRef = useRef(false);
  const { active } = useActiveMeasurementSession();

  const handleUploadStatus = useCallback(
    (nextStatus) => {
      props.onUploadStatus?.(nextStatus);

      // route away once upload begins
      if (nextStatus === "uploading" && !didRedirectRef.current) {
        didRedirectRef.current = true;
        navigate("/recording/tidal-breathing", { replace: true });
      }
    },
    [navigate, props],
  );

  const sessionKey = active?.id ?? "no-session";

  return (
    <Suspense
      fallback={
        <div className="flex h-full w-full items-center justify-center">
          <ClipLoader size={48} />
        </div>
      }
    >
      <RecordingTidalBreathing
        key={sessionKey}
        sessionId={active?.id ?? null}
        sessionMode={active?.mode ?? null}
        {...props}
        onUploadStatus={handleUploadStatus}
        onUploadProgress={props.onUploadProgress}
      />
    </Suspense>
  );
}
